import storageService from '../../services/storage';
import couponService from '../../services/coupon';
import glp1TreatmentService from '../../services/glp1-treatment';

/**
 * Builds the catalog combination from the answered option values.
 *
 * @param {object} answers the option values selected so far, keyed by question
 *
 * @returns {string} the combination
 */
const getCombination = (answers) => Object.values(answers).join('-');

/**
 * Shows the pre-rendered price variants matching the combination of the already-answered slides and hides the rest.
 *
 * @param {Element} slide   the slide element whose options should be updated
 * @param {object}  answers the answers already selected on previous slides
 */
const showPriceVariants = (slide, answers) => {
  const prefix = getCombination(answers);

  slide
    .querySelectorAll('[data-price-for]')
    .forEach((variant) => (variant.hidden = variant.dataset.priceFor !== prefix));
};

/**
 * Stores the checkout data of the product matching the selected combination and redirects to the next checkout step.
 */
const completeMedicationSelector = () => {
  const storage = storageService();
  const combination = getCombination(storage.sliderAnswers);
  const product = window.medicationSelector.products[combination];

  if (!product) {
    document.querySelector('#MedicationSelector .slider')?.classList.add('has-error');

    throw new Error(`No product found for the "${combination}" combination`);
  }

  storage.clearCheckoutData();
  storage.treatmentType = product.treatmentType;
  storage.isShipped = product.requiresShipping ? 'true' : 'false';
  storage.tests = [
    {
      name: product.name,
      slug: product.slug,
      price: product.price,
      id: product.id,
      ...(product.planId && { plan_id: product.planId }),
    },
  ];
  couponService().applyDefaultCoupon();
  storage.sliderAnswers = {};

  window.location.href = glp1TreatmentService().isGlp1TreatmentType() ? '/order' : '/select-pharmacy';
};

/**
 * Event listener for the medication selector slide change event
 */
document.addEventListener('MedicationSelectorSlideChange', (event) =>
  showPriceVariants(event.detail.slide, event.detail.answers),
);

/**
 * Event listener for the medication selector callback event
 */
document.addEventListener('MedicationSelectorCallback', completeMedicationSelector);
